export const SHIP_DIRECTIONS = <const>['forward', 'backward', 'none'];
export type ShipDirection = typeof SHIP_DIRECTIONS[number];

export const SHIP_DIRECTION_MULTIPLIER: { [Key in ShipDirection]: number } = {
    forward: 1,
    backward: -1,
    none: 0
};